import { StorySlug } from '../util/storyblok/types/api.types';

export const isCrossFlow = (toPath?: string, fromPath?: string): boolean =>
  // If toPath AND fromPath is on 'cases'
  !!(toPath?.includes(`${StorySlug.Cases}/`) && fromPath?.includes(`${StorySlug.Cases}/`));

export const isFadeTransition = (toPath?: string, fromPath?: string): boolean =>
  !!(
    (toPath?.includes(`${StorySlug.Location}/`) || toPath?.includes(`${StorySlug.Locations}`)) &&
    (fromPath?.includes(`${StorySlug.Location}/`) || fromPath?.includes(`${StorySlug.Locations}`))
  );
